// extracted by mini-css-extract-plugin
module.exports = {"vsAt":"eventOpponent_vsAt__1qBfs","vs":"eventOpponent_vs__22Q8J","at":"eventOpponent_at__3a9mU","opponentText":"eventOpponent_opponentText__2GK4R"};